"use strict";
var collapse_directive_1 = require('./collapse/collapse.directive');
exports.CollapseDirective = collapse_directive_1.CollapseDirective;
var collapse_module_1 = require('./collapse/collapse.module');
exports.CollapseModule = collapse_module_1.CollapseModule;



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/collapse.js
 ** module id = 136
 ** module chunks = 2
 **/